import { FlashbarProps } from "@cloudscape-design/components"
import { create } from 'zustand'

interface NotifyState {
    notifications: FlashbarProps.MessageDefinition[]
    add:    (type: string, message: string) => void
    remove: (id: string) => void
}  

export const useNotifyStore = create<NotifyState>((set) => ({
    notifications: [],
    add:    (type, message) => set((state) => ({ notifications: [ToNotification(type, message), ...state.notifications.slice(0,3)] })),
    remove: (id)            => set((state) => ({ notifications: state.notifications.filter(item => item.id !== id) })),
}))

export const Notify = (type: string, message: string) => useNotifyStore.getState().add(type, message)

function ToNotification(type: string, message: string) {
    let id = new Date().getTime().toString()
    
    return {
        type: type as FlashbarProps.Type,
        dismissible: true,
        dismissLabel: "Dismiss",
        onDismiss: () => {useNotifyStore.getState().remove(id)},
        content: message,
        id: id,
    } as FlashbarProps.MessageDefinition
}
